export const INSIGHT_TYPES = {
  SURVEY: 'survey',
  INTERVIEW: 'interview',
  ROUNDTABLE: 'roundtable',
  AI: 'ai',
  GLOBAL: 'global',
} as const;

export type InsightKey = typeof INSIGHT_TYPES[keyof typeof INSIGHT_TYPES];

export interface IInsightsDashboardItem {
  id: number,
  title: string,
  averagePosition: number,
  usageCount: number,
  standardName: string,
}

export interface IInsightsDashboardResponse {
  interview: IInsightsDashboardItem[],
  roundtable: IInsightsDashboardItem[],
  survey: IInsightsDashboardItem[],
  ai: IInsightsDashboardItem[],
  global: IInsightsDashboardItem[],
}

export type IInsightsDashboard = Record<InsightKey, IInsightsDashboardItem[]>;
